import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_ITEM,
  API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_TABLE,
} from 'constants/index'
import NoticeHelper from 'helpers/notice'
import {
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_FAILURE,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_FAILURE,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA,
  TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE,
} from './reducer'
import { SHOW_NOTICE } from '../../notice'

function* translationsLogbookEventCategoryFetchTableData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response || !response.error) {
      yield put({
        type: TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('TRANSLATION INTERFACE ERROR', error)
  }
}

function* translationsLogbookEventCategoryFetchFormData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_ITEM,
        {
          id: action.payload.entityId,
        },
      ),
    })
    if (!response || !response.error) {
      yield put({
        type: TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('TRANSLATION ERROR', error)
  }
}

function* translationsLogbookEventCategoryChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'PUT',
      partUrl: UrlHelper.create(
        API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_ITEM,
        { id: entityId },
      ),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Job Workflow Translation ${
          entityId === 0 ? 'create' : 'change'
        } successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`TRANSLATION INTERFACE ERROR: ${error}`)
  }
}

function* translationsLogbookEventCategorySaga() {
  yield takeLatest(
    TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_TABLE_DATA,
    translationsLogbookEventCategoryFetchTableData,
  )
  yield takeLatest(
    TRANSLATION_LOGBOOK_EVENT_CATEGORY_FETCH_FORM_DATA,
    translationsLogbookEventCategoryFetchFormData,
  )
  yield takeLatest(
    TRANSLATION_LOGBOOK_EVENT_CATEGORY_CHANGE,
    translationsLogbookEventCategoryChange,
  )
}

export default translationsLogbookEventCategorySaga
